import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./css/Blog.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../redux/postSlice";
import { useNavigate } from "react-router-dom";

export const Blog = () => {
  const dispatch = useDispatch();
  const { posts } = useSelector((state) => state.posts);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchPosts({ page: 1, limit: 1000 }));
  }, [dispatch]);

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  };

  // HTML etiketlerini temizleyen yardımcı fonksiyon
  const stripHtmlTags = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Excerpt oluşturan fonksiyon
  const createExcerpt = (content, maxLength = 150) => {
    const plainText = stripHtmlTags(content);
    return plainText.length > maxLength
      ? plainText.substring(0, maxLength) + "..."
      : plainText;
  };

  return (
    <div id="blog" className="blog-container">
      <h2 className="blog-title">Blog Yazılarım</h2>
      <div className="blog-grid">
        {posts.map((blog) => (
          <motion.div
            key={blog.id}
            className="blog-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
          >
            <div className="blog-image-wrapper">
              <img src={blog.image} alt={blog.title} className="blog-image" />
            </div>
            <div className="blog-content">
              <span className="blog-date">
                {new Date(blog.date).toLocaleDateString("tr-TR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
              <h3 className="blog-card-title">{blog.title}</h3>
              <p className="blog-excerpt">{createExcerpt(blog.content, 150)}</p>
              <a
                onClick={() => navigate(`/blog/${blog.slug}`)}
                className="blog-link"
                style={{ cursor: "pointer" }}
              >
                Devamını Oku →
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
